import { createResourceModule } from '../../../lib/resource/module.js';
import { amenityDetail } from './schemas.js';

export const amenities = createResourceModule({
  resource: 'amenities',
  basePath: '/v1/amenities',
  detail: amenityDetail,
});

export const amenityEndpoints = amenities.endpoints;
